// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1sjhm","left":"App_left__1hMfF","right":"App_right__LRumu","full":"App_full__3VI_h","combine":"App_combine__1jZWz"};